import "@/style/auth/forgotpassword.css";
import Container from "react-bootstrap/Container";
import { Row, Col, Spinner } from "react-bootstrap";
import { useVerifyDigitsState } from "@/hooks/auth/use-verify-digits";

const Verifycode = () => {
  const {
    handleValue,
    handleKeyDown,
    handleOtp,
    resendOtp,
    isVerifying,
    isResending,
    refs,
  } = useVerifyDigitsState();

  return (
    <>
      <Container fluid className="f-bg-color">
        <Row>
          <Col
            lg="4"
            md="5"
            sm="6"
            className="mx-auto  background-white f-modal-style rounded cursor_P col-11"
          >
            <div className="ps-5 pe-5">
              <h5 className="text-center mt-2">Verification</h5>
              <p className="text-center mt-2 font-ss">
                We have send you verification Code on your given email Enter
                code to continue
              </p>
            </div>
            <Col lg="9" xl="7" md="8" sm="8" className="mx-auto col-9">
              <Row>
                <Col lg="2" md="2" sm="2" className="ps-0 col-2">
                  <input
                    type="text"
                    name="one1"
                    className="form-control verify-input text-center"
                    min="0"
                    max="9"
                    pattern="[0-9]"
                    maxlength="1"
                    step="1"
                    onChange={(e) => handleValue(e)}
                    onKeyDown={handleKeyDown}
                    ref={refs.one1}
                  />
                </Col>
                <Col lg="2" md="2" sm="2" className="ps-0 col-2">
                  <input
                    type="text"
                    name="one2"
                    className="form-control verify-input text-center"
                    min="0"
                    max="9"
                    pattern="[0-9]"
                    maxlength="1"
                    step="1"
                    onChange={(e) => handleValue(e)}
                    onKeyDown={handleKeyDown}
                    ref={refs.one2}
                  />
                </Col>

                <Col lg="2" md="2" sm="2" className="ps-0 col-2">
                  <input
                    type="text"
                    name="one3"
                    className="form-control verify-input text-center"
                    min="0"
                    max="9"
                    pattern="[0-9]"
                    maxlength="1"
                    step="1"
                    onChange={(e) => handleValue(e)}
                    onKeyDown={handleKeyDown}
                    ref={refs.one3}
                  />
                </Col>
                <Col lg="2" md="2" sm="2" className="ps-0 col-2">
                  <input
                    type="text"
                    name="one4"
                    className="form-control verify-input text-center"
                    min="0"
                    max="9"
                    pattern="[0-9]"
                    maxlength="1"
                    step="1"
                    onChange={(e) => handleValue(e)}
                    onKeyDown={handleKeyDown}
                    ref={refs.one4}
                  />
                </Col>
                <Col lg="2" md="2" sm="2" className="ps-0 col-2">
                  <input
                    type="text"
                    name="one5"
                    className="form-control verify-input text-center"
                    min="0"
                    max="9"
                    pattern="[0-9]"
                    maxlength="1"
                    step="1"
                    onChange={(e) => handleValue(e)}
                    onKeyDown={handleKeyDown}
                    ref={refs.one5}
                  />
                </Col>
                <Col lg="2" md="2" sm="2" className="ps-0 col-2">
                  <input
                    type="text"
                    name="one6"
                    className="form-control verify-input text-center"
                    min="0"
                    max="9"
                    pattern="[0-9]"
                    maxlength="1"
                    step="1"
                    onChange={(e) => handleValue(e)}
                    onKeyDown={handleKeyDown}
                    ref={refs.one6}
                  />
                </Col>
              </Row>
            </Col>
            <Row>
              <div className="d-flex justify-content-center mt-4">
                <button
                  className="btn btn-primary ps-4 pe-4 pt-2 pb-2 w-50"
                  onClick={handleOtp}
                  disabled={isVerifying}
                >
                  {isVerifying ? <Spinner animation="border" size="sm" /> : "Verify"}
                </button>
              </div>
            </Row>

            <Row>
              <div className="d-flex justify-content-center mt-2">
                <button className="otp-settingbtn" onClick={resendOtp} disabled={isResending}>
                  {isResending ? <Spinner animation="border" size="sm" /> : "Resend OTP"}
                </button>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Verifycode;
